import { default as iframe7Cr8jRpgeRMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/chirashi/iframe.vue?macro=true";
import { default as indexLf9ughw1juMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/chirashi/index.vue?macro=true";
import { default as vieweruhdkNbx2KoMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/chirashi/viewer.vue?macro=true";
import { default as _91id_93oJsNU1uQyvMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/content/[id].vue?macro=true";
import { default as indexoWd8rCMzueMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/faq/index.vue?macro=true";
import { default as indexfiBNOxgb9oMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/index.vue?macro=true";
import { default as indexHhu23u5q17Meta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/maker-theme/index.vue?macro=true";
import { default as indexI1DhEmm3otMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/maker-theme/survey/index.vue?macro=true";
import { default as indexmqQMUHx1wHMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/my-store/index.vue?macro=true";
import { default as _91type_935tSTTbepVRMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/my-store/search/[type].vue?macro=true";
import { default as indexeR5VtqqqR9Meta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/my-store/search/index.vue?macro=true";
import { default as indexCWsdJqQlRgMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/preview/chirashi/index.vue?macro=true";
import { default as viewerczT5ufwkyWMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/preview/chirashi/viewer.vue?macro=true";
import { default as indexJf9rK79KQaMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/privacy-policy/index.vue?macro=true";
import { default as indexnnfBZjvMKZMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/product/index.vue?macro=true";
import { default as indexW3bSgaFr6DMeta } from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/theme/index.vue?macro=true";
export default [
  {
    name: iframe7Cr8jRpgeRMeta?.name ?? "chirashi-iframe",
    path: iframe7Cr8jRpgeRMeta?.path ?? "/chirashi/iframe",
    meta: iframe7Cr8jRpgeRMeta || {},
    alias: iframe7Cr8jRpgeRMeta?.alias || [],
    redirect: iframe7Cr8jRpgeRMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/chirashi/iframe.vue").then(m => m.default || m)
  },
  {
    name: indexLf9ughw1juMeta?.name ?? "chirashi",
    path: indexLf9ughw1juMeta?.path ?? "/chirashi",
    meta: indexLf9ughw1juMeta || {},
    alias: indexLf9ughw1juMeta?.alias || [],
    redirect: indexLf9ughw1juMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/chirashi/index.vue").then(m => m.default || m)
  },
  {
    name: vieweruhdkNbx2KoMeta?.name ?? "chirashi-viewer",
    path: vieweruhdkNbx2KoMeta?.path ?? "/chirashi/viewer",
    meta: vieweruhdkNbx2KoMeta || {},
    alias: vieweruhdkNbx2KoMeta?.alias || [],
    redirect: vieweruhdkNbx2KoMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/chirashi/viewer.vue").then(m => m.default || m)
  },
  {
    name: _91id_93oJsNU1uQyvMeta?.name ?? "content-id",
    path: _91id_93oJsNU1uQyvMeta?.path ?? "/content/:id()",
    meta: _91id_93oJsNU1uQyvMeta || {},
    alias: _91id_93oJsNU1uQyvMeta?.alias || [],
    redirect: _91id_93oJsNU1uQyvMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/content/[id].vue").then(m => m.default || m)
  },
  {
    name: indexoWd8rCMzueMeta?.name ?? "faq",
    path: indexoWd8rCMzueMeta?.path ?? "/faq",
    meta: indexoWd8rCMzueMeta || {},
    alias: indexoWd8rCMzueMeta?.alias || [],
    redirect: indexoWd8rCMzueMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/faq/index.vue").then(m => m.default || m)
  },
  {
    name: indexfiBNOxgb9oMeta?.name ?? "index",
    path: indexfiBNOxgb9oMeta?.path ?? "/",
    meta: indexfiBNOxgb9oMeta || {},
    alias: indexfiBNOxgb9oMeta?.alias || [],
    redirect: indexfiBNOxgb9oMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexHhu23u5q17Meta?.name ?? "maker-theme",
    path: indexHhu23u5q17Meta?.path ?? "/maker-theme",
    meta: indexHhu23u5q17Meta || {},
    alias: indexHhu23u5q17Meta?.alias || [],
    redirect: indexHhu23u5q17Meta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/maker-theme/index.vue").then(m => m.default || m)
  },
  {
    name: indexI1DhEmm3otMeta?.name ?? "maker-theme-survey",
    path: indexI1DhEmm3otMeta?.path ?? "/maker-theme/survey",
    meta: indexI1DhEmm3otMeta || {},
    alias: indexI1DhEmm3otMeta?.alias || [],
    redirect: indexI1DhEmm3otMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/maker-theme/survey/index.vue").then(m => m.default || m)
  },
  {
    name: indexmqQMUHx1wHMeta?.name ?? "my-store",
    path: indexmqQMUHx1wHMeta?.path ?? "/my-store",
    meta: indexmqQMUHx1wHMeta || {},
    alias: indexmqQMUHx1wHMeta?.alias || [],
    redirect: indexmqQMUHx1wHMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/my-store/index.vue").then(m => m.default || m)
  },
  {
    name: _91type_935tSTTbepVRMeta?.name ?? "my-store-search-type",
    path: _91type_935tSTTbepVRMeta?.path ?? "/my-store/search/:type()",
    meta: _91type_935tSTTbepVRMeta || {},
    alias: _91type_935tSTTbepVRMeta?.alias || [],
    redirect: _91type_935tSTTbepVRMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/my-store/search/[type].vue").then(m => m.default || m)
  },
  {
    name: indexeR5VtqqqR9Meta?.name ?? "my-store-search",
    path: indexeR5VtqqqR9Meta?.path ?? "/my-store/search",
    meta: indexeR5VtqqqR9Meta || {},
    alias: indexeR5VtqqqR9Meta?.alias || [],
    redirect: indexeR5VtqqqR9Meta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/my-store/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexCWsdJqQlRgMeta?.name ?? "preview-chirashi",
    path: indexCWsdJqQlRgMeta?.path ?? "/preview/chirashi",
    meta: indexCWsdJqQlRgMeta || {},
    alias: indexCWsdJqQlRgMeta?.alias || [],
    redirect: indexCWsdJqQlRgMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/preview/chirashi/index.vue").then(m => m.default || m)
  },
  {
    name: viewerczT5ufwkyWMeta?.name ?? "preview-chirashi-viewer",
    path: viewerczT5ufwkyWMeta?.path ?? "/preview/chirashi/viewer",
    meta: viewerczT5ufwkyWMeta || {},
    alias: viewerczT5ufwkyWMeta?.alias || [],
    redirect: viewerczT5ufwkyWMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/preview/chirashi/viewer.vue").then(m => m.default || m)
  },
  {
    name: indexJf9rK79KQaMeta?.name ?? "privacy-policy",
    path: indexJf9rK79KQaMeta?.path ?? "/privacy-policy",
    meta: indexJf9rK79KQaMeta || {},
    alias: indexJf9rK79KQaMeta?.alias || [],
    redirect: indexJf9rK79KQaMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexnnfBZjvMKZMeta?.name ?? "product",
    path: indexnnfBZjvMKZMeta?.path ?? "/product",
    meta: indexnnfBZjvMKZMeta || {},
    alias: indexnnfBZjvMKZMeta?.alias || [],
    redirect: indexnnfBZjvMKZMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexW3bSgaFr6DMeta?.name ?? "theme",
    path: indexW3bSgaFr6DMeta?.path ?? "/theme",
    meta: indexW3bSgaFr6DMeta || {},
    alias: indexW3bSgaFr6DMeta?.alias || [],
    redirect: indexW3bSgaFr6DMeta?.redirect || undefined,
    component: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/pages/theme/index.vue").then(m => m.default || m)
  }
]